import {createContext} from 'react'

export const UserRoleInitialState = {
  isReady: false,
  isAuthorized: false,
  userRole: undefined,
  userAccessRules: [],
  error: null,
}

export const UserRoleContext = createContext(UserRoleInitialState)